import { ASSESSMENT_ENVIRONMENT_HELP_URL } from '~~/package/const/ExternalLink';

/**
 * 안내 박스 마지막 줄에 들어가는 링크의 클래스.
 *
 * 두 팝업이 각자 `:deep(.helpLink)` 로 스타일을 준다 — `v-html` 로 주입된 노드에는 scoped 속성이
 * 붙지 않아 일반 scoped 규칙이 닿지 않는다.
 */
const HELP_LINK_CLASS = 'helpLink';

/**
 * "자세한 해결 방법은 [도움말 보기] 확인" 줄을 그릴지.
 *
 * **운영팀 확정 링크를 받기 전까지 끈다.** `ASSESSMENT_ENVIRONMENT_HELP_URL` 이 아직 자리표시자라,
 * 켜 두면 응시자가 존재하지 않는 문서로 이동한다 — 실패 안내가 또 다른 막다른 길이 된다.
 *
 * 되살리는 순서(BR-1761 / BR-1762):
 *   1. `package/const/ExternalLink.ts` 의 `ASSESSMENT_ENVIRONMENT_HELP_URL` 을 확정 링크로 교체
 *   2. 로케일 4개(ko/en/ja/vi)에 `skillCertify-environment-check-help-detail` 추가
 *      (값 안에 `{link}` 자리표시자 필수 — ko 예: "자세한 해결 방법은 {link} 확인")
 *   3. 이 상수를 `true` 로 변경
 */
export const IS_HELP_DETAIL_ENABLED: boolean = false;

/**
 * BR-1761 / BR-1762 — "자세한 해결 방법은 [도움말 보기] 확인" 한 줄을 만든다.
 *
 * 기본 감독(화면 공유)과 강화 감독(Proctive) 두 팝업이 같은 문장을 쓴다. 각자 조립하면
 * 링크 속성(새 탭·rel)이나 문구가 한쪽만 바뀌어 어긋나므로 한 곳에 둔다.
 *
 * 새 탭으로 여는 이유: 팝업이 그대로 남아야 응시자가 문서를 읽고 돌아와 바로 재시도할 수 있다.
 * `rel="noopener noreferrer"` 는 새 탭이 `window.opener` 로 응시 화면을 건드리지 못하게 한다.
 *
 * @param t vue-i18n 의 번역 함수. 컴포넌트의 스코프를 그대로 쓰려고 주입받는다.
 */
export function buildHelpDetailHtml(t: (key: string, named?: Record<string, unknown>) => string): string {
    const link = `<a class="${HELP_LINK_CLASS}" href="${ASSESSMENT_ENVIRONMENT_HELP_URL}"`
        + ` target="_blank" rel="noopener noreferrer">${t('skillCertify-environment-check-help-link-button')}</a>`;
    return t('skillCertify-environment-check-help-detail', { link });
}
